@let apartment = apartment$ | async;
@if (apartment === undefined) {
  <homey-page-title title="Not found"/>
  <p class="mb-8">Unfortunately this apartment could not be found...</p>
  <a class="w-full" pButton routerLink="/apartments" [replaceUrl]="true"><span pButtonLabel>View all apartments</span></a>
} @else if (apartment) {
  <article homeyApartmentDetailPageContent
    [apartment]="apartment"
    [householdSize]="1"
    [showH2]="true"
    [relevantApartmentsInput]="{ type: 'all' }"
  >
    <homey-apartment-detail-info-item
      apartmentUnits
      icon="pi-warehouse"
      title="Units"
    >
      @if (apartment.type === "regular") {
        <homey-regular-eligible-units [eligibleUnits]="apartment.unitTypes" />
      }
      @else {
        <homey-senior-eligible-units [eligibleUnits]="apartment.unitTypes" />
      }
    </homey-apartment-detail-info-item>
    <ng-container otherBlocks>
      <div>
        <p class="font-medium text-xl mt-2 mb-6 text-center">
          Want to know if you're eligible?
        </p>
        <div class="flex flex-row justify-center">
          <a pButton [routerLink]="initialSignupRoute" size="small" severity="info"><span pButtonLabel>Check eligibility</span></a>
        </div>
        <p-divider/>
      </div>
    </ng-container>
  </article>

  <homey-lotteries-and-footer [defaultSignupRoute]="initialSignupRoute">
    <ng-container footerTitle>
      Apply in minutes<br />
      <span class="text-orange-gradient">
        We’ll handle the rest.
      </span>
    </ng-container>
  </homey-lotteries-and-footer>
}
